import React, { Component } from "react";
import {
  NormalButtonBackend,
  NormalCheckbox,
  NormalInput,
} from "component/common";
import { withTranslation } from "react-i18next";
import { updateCommon, ApptSecondaryStatuses } from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toast } from "service/toast";

export default class Editsecondarystatusclass extends Component {
  state = {
    itemId: null,
    desc: null,
    colorcode: null,
    checked: true,
  };

  componentDidMount = () => {
    let { itemId } = this.state;
    itemId = window.location.pathname.split("/")[4];
    this.setState({ itemId });
    console.log(itemId);
    this.Listofsecondarylist(itemId);
  };

  Listofsecondarylist = async (code) => {
    let { temp, desc, colorcode, checked } = this.state;
    await this.props.ApptSecondaryStatuses().then((res) => {
      let objIndex = res.findIndex((obj) => obj.ssCode == code);
      console.log(objIndex);
      temp = res[objIndex];
      this.setState({
        temp,
      });
      desc = temp.ssDesc;
      colorcode = temp.ssColorCode;
      checked = temp.active;
      this.setState({
        desc,
        colorcode,
        checked,
      });
    });
  };

  handleinput = ({ target: { value, name } }) => {
    console.log(value, name);
    let { code, desc, colorcode, checked } = this.state;
    if (name == "desc") {
      desc = value;
      this.setState({ desc });
    }
    if (name == "colorcode") {
      colorcode = value;
      this.setState({ colorcode });
    }
    if (name == "checked") {
      checked = value;
      this.setState({ checked });
    }
  };

  Addnewsecondary = async () => {
    let { desc, colorcode, checked, itemId } = this.state;
    if (desc == null) {
      Toast({
        type: "error",
        message: "Description required",
      });
    } else {
      let editdata = {
        ssCode: itemId,
        ssDesc: desc,
        ssColorCode: colorcode,
        active: checked,
      };
      await this.props
        .updateCommon(
          `ApptSecondaryStatuses/update?where=%7B%22ssCode%22%3A%20%22${this.state.itemId}%22%7D
    `,
          editdata
        )
        .then((data) => {
          Toast({
            type: "success",
            message: "Updated Successfully",
          });
          this.props.history.push("/admin/backend/appointment/secondary")
          this.Listofsstate();
        })
        .catch((e) => console.log(e));
    }
  };

  Listofsstate = async () => {
    await this.props.ApptSecondaryStatuses().then((res) => {
      console.log(res);
    });
  };

  render() {
    let { t } = this.props;
    let { itemId, desc, colorcode, checked } = this.state;
    return (
      <div className="bg-white">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <h5 className="mt-3 mb-0 label-head text-center text-md-left">
                Appointment Secondary Status
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="mt-3">
                <span>{t("Code")}</span>
                <span style={{ color: "red" }}>*</span>
                <div className="input-group">
                  <NormalInput
                    value={itemId}
                    name="code"
                    onChange={this.handleinput}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="mt-3">
                <p>{t("Color Code")}</p>
                <div className="input-group">
                  <NormalInput
                    value={colorcode}
                    onChange={this.handleinput}
                    name="colorcode"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="mt-3">
                <span>{t("Description")}</span>
                <span style={{ color: "red" }}>*</span>
                <div className="input-group">
                  <NormalInput
                    value={desc}
                    name="desc"
                    onChange={this.handleinput}
                  />
                </div>
              </div>
              <div className="mt-3">
                <div className="mt-3 p-1"> </div>
                <input
                  type="color"
                  className="mt-3"
                  onChange={this.handleinput}
                  style={{ width: 70 }}
                  name="colorcode"
                />
              </div>
            </div>
          </div>
          <div className="mt-3">
            <div className="d-flex input-group">
              <NormalCheckbox
                checked={checked}
                name="checked"
                onChange={this.handleinput}
              />
              <p>{t("is Currently Active")}</p>
            </div>
          </div>
          <div className="mt-3 col-12 m-0 p-0 d-flex justify-content-center justify-content-md-start">
            <div className="col-6 p-0 col-md-2">
              <NormalButtonBackend
                mainbg={true}
                label={"Update"}
                onClick={() => this.Addnewsecondary()}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateCommon,
      ApptSecondaryStatuses,
    },
    dispatch
  );
};

export const Editsecondarystatus = withTranslation()(
  connect(null, mapDispatchToProps)(Editsecondarystatusclass)
);
